'use strict';

var React = require('react');

//components
var TextInput = require('../Common/TextInput.jsx');

//Action
var YourDetailsActions = require('../../actions/YourDetailsActions');

var ContentService = require('../../services/ContentService.js');

var Occupation = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        data: React.PropTypes.object.isRequired,
        productId: React.PropTypes.number,
        section: React.PropTypes.string,
        errorList: React.PropTypes.array
    },

    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            errorList: []
        };
    },

    handleSaveOccupation: function (event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
    },

    render: function () {
        var Content = ContentService.getContent().yourDetails;
        return (
                <div>
                    <TextInput id={this.props.section + 'occupation' + this.props.index}
                               label="What is your occupation?"
                               value={this.props.data.occupation}
                               onBlur={this.handleSaveOccupation}
                               helpText={this.props.data.occupationReadonly ? '' : Content.retiredHelp}
                               model="occupation"
                               errorList={this.props.errorList}
                               isDisabled={this.props.data.occupationReadonly} />
                </div>
        );
    }
});

module.exports = Occupation;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Occupation.jsx